var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#7c7d7d}.cls-3{fill:#747575}.cls-6{fill:#6fabe6}.cls-7{fill:#82bcf4}.cls-8{fill:#374f68}"))), /*#__PURE__*/React.createElement("g", {
    id: "Ecommerce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 31H1V7a4 4 0 0 1 4-4h38a4 4 0 0 1 4 4z",
    style: {
      fill: "#dad7e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43 37H5a4 4 0 0 1-4-4v-2h46v2a4 4 0 0 1-4 4zM31 45H17l2-8h10l2 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35 46H13a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47 7v22H12a6 6 0 0 1-6-6V3h37a4 4 0 0 1 4 4z",
    style: {
      fill: "#edebf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 31v2a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4v-2z",
    style: {
      fill: "#919191"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.5 39h-11l.5-2h10l.5 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34 11c-1.79 8-1.41 6.34-2 9H17l-1.38-9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34 11-1.56 7h-7.29a6 6 0 0 1-5.93-5.09L18.93 11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M18 20a1 1 0 0 0-1 1 1 1 0 0 1-1-.85c-.27-1.69 0 0-1.87-12.15H12a1 1 0 0 1 0-2h3a1 1 0 0 1 1 .85c2.24 14.6 2 12.98 2 13.15z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M29 24H18a3 3 0 0 1-.29-6c.31 2.05.29 1.85.29 2a1 1 0 0 0 0 2h11a1 1 0 0 1 0 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.15 21.5A1 1 0 0 0 18 23c11.75 0 11.43-.2 11.85.5A1 1 0 0 0 29 22c-11.75 0-11.43.2-11.85-.5z",
    style: {
      fill: "#2c435e"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21 26a1 1 0 0 0-2 0 1 1 0 0 0 2 0M27 26a1 1 0 0 0-2 0 1 1 0 0 0 2 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.71 23.29a1 1 0 0 1-1.42 1.42L37 23.41V24a1 1 0 0 1-2 0c0-4.52-.6-4 4-4a1 1 0 0 1 0 2h-.59z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m39.87 24.49-4.35-4.35C35.63 20 36.66 20 39 20a1 1 0 0 1 0 2h-.59c1.35 1.34 1.92 1.7 1.46 2.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.ed974f902f15e48d72483c6eba0f3924.svg";
export { ForwardRef as ReactComponent };